import { fromJS } from 'immutable';
import { MENU_GET_TREE_LOADED } from '../../../actions/Entity/Menu';
var initialState = fromJS({});
export default function menu() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case MENU_GET_TREE_LOADED:
      {
        return state.set(action.menuId, fromJS(action.data));
      }
    default:
      return state;
  }
}